var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disclaimer)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.disclaimer.value),expression:"disclaimer.value"}],staticClass:"disclaimer-tooltip"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }